import { Container } from "../Container/Container";
import style from "./Footer.module.css";
import logo from "../../images/logo.svg"

export const Footer = () => {
  return (
    <>
      
        <footer className={style.footer}>
          <Container>
          <div className={style.footerBlock}>
            <div className={style.header__main}>
       <img src={logo} alt="" />
       <p className={style.header__text}>Подорожники</p>
        </div>
            <ul className={style.footerlistSocials}>
              <li className={style.footerItemSocial}>
                <svg 
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    d="M22 12.9617C22 7.40514 17.5229 2.90063 12 2.90063C6.47715 2.90063 2 7.40514 2 12.9617C2 17.9834 5.65684 22.1458 10.4375 22.9006V15.87H7.89844V12.9617H10.4375V10.7452C10.4375 8.22359 11.9305 6.83075 14.2146 6.83075C15.3088 6.83075 16.4531 7.02726 16.4531 7.02726V9.50324H15.1922C13.95 9.50324 13.5625 10.2789 13.5625 11.0745V12.9617H16.3359L15.8926 15.87H13.5625V22.9006C18.3432 22.1458 22 17.9836 22 12.9617Z"
                    fill="black"
                  />
                </svg>
              </li>
              <li className={style.footerItemSocial}>
                <svg 
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    d="M12.0051 5.52423C14.4095 5.52423 14.6941 5.53491 15.6395 5.5771C16.5186 5.6159 16.9927 5.76326 17.3094 5.88643C17.7278 6.04841 18.0298 6.24526 18.3426 6.55797C18.6592 6.87461 18.8521 7.17326 19.0175 7.5917C19.1406 7.90835 19.288 8.38585 19.3268 9.26154C19.369 10.2109 19.3797 10.4955 19.3797 12.8965C19.3797 15.2975 19.369 15.5854 19.3268 16.5314C19.288 17.4105 19.1406 17.8846 19.0175 18.2013C18.8555 18.6197 18.6592 18.9218 18.3459 19.2345C18.0293 19.5511 17.7306 19.744 17.3128 19.9094C16.9961 20.0325 16.518 20.1799 15.6429 20.2187C14.6935 20.2609 14.409 20.2716 12.008 20.2716C9.60697 20.2716 9.31901 20.2609 8.37301 20.2187C7.49394 20.1799 7.01981 20.0325 6.70317 19.9094C6.28472 19.7474 5.9827 19.5511 5.66943 19.2378C5.35278 18.9212 5.15987 18.6225 4.99452 18.2047C4.87135 17.888 4.72399 17.41 4.68519 16.5348C4.643 15.5854 4.63232 15.3009 4.63232 12.8999C4.63232 10.4989 4.643 10.2109 4.68519 9.26492C4.72399 8.38585 4.87135 7.91172 4.99452 7.59508C5.1565 7.17663 5.35335 6.87461 5.66606 6.56134C5.9827 6.2447 6.28135 6.05178 6.69979 5.88643C7.01644 5.76326 7.49394 5.6159 8.36963 5.5771C9.31507 5.53491 9.60022 5.52423 12.0046 5.52423H12.0051ZM12.0051 3.90388C9.56197 3.90388 9.25658 3.91457 8.29652 3.95675C7.34039 3.99893 6.68292 4.1536 6.11375 4.37519C5.51982 4.60691 5.01702 4.91287 4.51815 5.41568C4.01534 5.91511 3.70938 6.41736 3.47766 7.00791C3.25606 7.58102 3.1014 8.23455 3.05922 9.19068C3.01703 10.1541 3.00635 10.4595 3.00635 12.9027C3.00635 15.3459 3.01703 15.6513 3.05922 16.6113C3.1014 17.5674 3.25606 18.2249 3.47766 18.7941C3.70994 19.388 4.01534 19.8908 4.51815 20.3897C5.01702 20.8886 5.51982 21.1985 6.11037 21.4268C6.68348 21.6484 7.33702 21.8031 8.29314 21.8452C9.25264 21.8874 9.5586 21.8981 12.0018 21.8981C14.4449 21.8981 14.7509 21.8874 15.7104 21.8452C16.6665 21.8031 17.324 21.6484 17.8932 21.4268C18.4837 21.1985 18.9865 20.8891 19.4854 20.3897C19.9843 19.8902 20.2942 19.388 20.5225 18.7975C20.7441 18.2243 20.8988 17.5708 20.941 16.6147C20.9831 15.6552 20.9938 15.3492 20.9938 12.9061C20.9938 10.4629 20.9831 10.1575 20.941 9.19743C20.8988 8.2413 20.7441 7.58383 20.5225 7.01466C20.3009 6.4168 19.995 5.91455 19.4927 5.41512C18.9938 4.91625 18.491 4.60635 17.9005 4.37801C17.3274 4.15641 16.6738 4.00174 15.7177 3.95956C14.7548 3.91401 14.4489 3.90332 12.0057 3.90332L12.0051 3.90388Z"
                    fill="black"
                  />
                  <path
                    d="M12.0049 8.28003C9.45317 8.28003 7.38232 10.3503 7.38232 12.9026C7.38232 15.4549 9.45261 17.5252 12.0049 17.5252C14.5572 17.5252 16.6275 15.4549 16.6275 12.9026C16.6275 10.3509 14.5572 8.28003 12.0049 8.28003ZM12.0049 15.9009C10.3491 15.9009 9.00661 14.5584 9.00661 12.9026C9.00661 11.2468 10.3491 9.90431 12.0049 9.90431C13.6607 9.90431 15.0032 11.2468 15.0032 12.9026C15.0032 14.5584 13.6607 15.9009 12.0049 15.9009Z"
                    fill="black"
                  />
                  <path
                    d="M17.8886 8.09736C17.8886 8.69353 17.4054 9.17665 16.8093 9.17665C16.2131 9.17665 15.73 8.69353 15.73 8.09736C15.73 7.50119 16.2131 7.01807 16.8093 7.01807C17.4054 7.01807 17.8886 7.50119 17.8886 8.09736Z"
                    fill="black"
                  />
                </svg>
              </li>
              <li className={style.footerItemSocial}>
                <svg 
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    d="M17.1761 4.90063H19.9362L13.9061 11.678L21 20.9006H15.4456L11.0951 15.3072L6.11723 20.9006H3.35544L9.80517 13.6514L3 4.90063H8.69545L12.6279 10.0133L17.1761 4.90063ZM16.2073 19.276H17.7368L7.86441 6.43991H6.2232L16.2073 19.276Z"
                    fill="black"
                  />
                </svg>
              </li>
              <li className={style.footerItemSocial}>
                <svg 
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    d="M21.5931 7.86097C21.4792 7.43837 21.2566 7.05297 20.9475 6.74313C20.6383 6.4333 20.2534 6.20983 19.8311 6.09497C18.2651 5.66497 12.0001 5.65797 12.0001 5.65797C12.0001 5.65797 5.73609 5.65097 4.16909 6.06197C3.74701 6.18211 3.36291 6.40874 3.05365 6.7201C2.7444 7.03146 2.52037 7.41709 2.40309 7.83997C1.99009 9.40597 1.98609 12.654 1.98609 12.654C1.98609 12.654 1.98209 15.918 2.39209 17.468C2.62209 18.325 3.29709 19.002 4.15509 19.233C5.73709 19.663 11.9851 19.67 11.9851 19.67C11.9851 19.67 18.2501 19.677 19.8161 19.267C20.2386 19.1523 20.6238 18.9294 20.9337 18.6201C21.2436 18.3109 21.4675 17.9262 21.5831 17.504C21.9971 15.939 22.0001 12.692 22.0001 12.692C22.0001 12.692 22.0201 9.42697 21.5931 7.86097ZM9.99609 15.663L10.0011 9.66297L15.2081 12.668L9.99609 15.663Z"
                    fill="black"
                  />
                </svg>
              </li>
            </ul>
            <ul className={style.footerList}>
            <li className={style.footerPages}>
              <a href="/" className={style.footerLink}>
                Головна
              </a>
              </li>
              <li className={style.footerPages}>
              <a href="/" className={style.footerLink}>
                Історії
              </a>
              </li>
              <li className={style.footerPages}>
              <a href="/" className={style.footerLink}>
                Мандрівники
              </a>
            </li>
            </ul>
          </div>
          <p className={style.footerPrivate}>© 2025 Подорожники. Усі права захищені.</p>
          </Container>
          </footer>
      
    </>
  );
};
